import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType } from 'vue'
import {
  IFacturaEDialogModel
} from '@/components/billing/FacturaEDialog/types/FacturaEDialogTypes'
import LfBlueTitleComponent from '@/components/HeaderTitle/LfBlueTitleComponent.vue'
import LfActionsBarComponent from '@/components/ActionsBar/LfActionsBarComponent.vue'
import { LabelButtonVariant } from '@/components/forms/buttons/types/ButtonTypes'
import { ActionBarButton, ActionName } from '@/components/ActionsBar/types/ActionBarComponentTypes'
import useActionsFacturaEDialog from '@/components/billing/FacturaEDialog/composables/useActionsFacturaEDialog'
import { useI18n } from 'vue-i18n-composable'
import LfErrorListComponent from '@/components/forms/message/LfErrorListComponent.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckListComponent',
  props: {
  model: {
    type: Object as PropType<IFacturaEDialogModel>,
    required: true
  }
},
  setup(__props) {

const props = __props;



const { t } = useI18n()

const texts = {
  title: t('components.facturae_dialog.validator.title').toString(),
  caption: t('components.facturae_dialog.validator.caption').toString(),
  body: t('components.facturae_dialog.validator.body').toString(),
  accept: t('action_buttons.accept').toString(),
}

const { close } = useActionsFacturaEDialog(props.model)

const buttons = computed(() => {
  return [
    {
      tooltip: texts.accept,
      variant: LabelButtonVariant.SOLID,
      action: ActionName.ACCEPT,
      enabled: true
    },
  ] as ActionBarButton []
})

const icon = computed(() => {
  return require('@/assets/images/svg/Track-Right.svg')
})

const errorMessages = computed(() => {
  return props.model.validatorErrorList.map((validatorError) => validatorError.message);
});


return { __sfc: true,props, t, texts, close, buttons, icon, errorMessages, LfBlueTitleComponent, LfActionsBarComponent, LfErrorListComponent }
}

})